import React, { FC, useCallback } from 'react';
import { useField } from 'formik';

import { InputProps } from 'app/design-system/components/Input';
import InputWithAnalytics from 'app/widgets/InputsWithAnalytics/Input';

import styles from './InputField.module.scss';

type InputFieldProps = InputProps & {
  name: string;
};

const InputField: FC<InputFieldProps> = (props) => {
  const [field, meta, { setTouched }] = useField(props.name);

  const onFocus = useCallback(() => {
    setTouched(false);
  }, []);

  return (
    <InputWithAnalytics
      {...field}
      {...props}
      className={styles.root}
      onFocus={onFocus}
      error={!!(meta.touched && meta.error)}
      required />
  );
};

export default InputField;
